import { Component,  ElementRef,  EventEmitter,  Input, Output } from '@angular/core';
import { OnsiteBlock } from 'globals/store/onsite.data';
import { LabelObject } from 'globals/store/events.data';
import { ActivityReselectorData } from '../../store/reselectors/onsite.reselector';
import { TagPopupComponent } from './tag-popup.component';
import { CommonModule } from '@angular/common';
import { IconComponent } from 'src/app/components/icon/icon.component';


@Component({
    selector: 'activity-brick',
    template: `
<div class="data" [ngClass]="{completed: activity.completed}">
  <span class="time">{{activity.time}}</span>
  <icon class="tick" *ngIf="activity.completed" icon="tick_12px"></icon>
  <span class="title2">{{activity.title}}</span>
</div>
<tag-popup 
  [data]="activityData" 
  [labelIds]="activity.labels"
  [labelMap]="activityLabels"
  [showPopup]="showPopup"
  (onPopupTop)="onPopupTop.emit($event)"
  (hidePopup)="hidePopup.emit()"
></tag-popup>
`,
    styleUrls: [`./activity-brick.scss`],
    standalone: true,
    imports: [TagPopupComponent, IconComponent, CommonModule],
})
export class ActivityBrickComponent {
  @Input() activity: OnsiteBlock
  @Input() activityData: ActivityReselectorData
  @Input() activityLabels: LabelObject
  @Output() onPopupTop: EventEmitter<boolean> = new EventEmitter()
  @Output() hidePopup: EventEmitter<null> = new EventEmitter()
  @Input() showPopup: boolean = false

  popupTop = false
  MAX_TAGS = 5

  constructor(private elRef: ElementRef) { }

  async openPopup() {
    const el = this.elRef.nativeElement
    this.popupTop= el.getBoundingClientRect().top / window.innerHeight > 0.70 // This is not 50% because cannot get this to show outside of schedule lane
    this.onPopupTop.emit(this.popupTop)
  }

  trackByFn(index) {
    return index;
  }
}

